module.exports = __webpack_public_path__ + "static/media/PATS_6-1363w.75c24724.webp";